/**
 * @typedef {Readonly<{ handleCloseSideDrawer?: () => void, auth: import('../types/AuthContext').default }>} Props
 * @typedef {import('../shared/AuthProvider/Roles').Roles} Role
 */
import { AdminNavigationList } from './Admin';
import { AgentNavigationList } from './Agent';
import { HomeownerNavigationList } from './Homeowner';
import { ProfileNavigationList } from './Profile';
import { withAuth } from '../shared/AuthProvider';
import React from 'react';
import roles from '@mooveguru/yhh-shared-config/users/roles.json';

/** @extends {React.Component<Props>} */
class AppNavigation extends React.Component {
	/**
	 * Keep single-role navigation unchanged; only users who can access multiple
	 * primary role menus get collapsible top-level sections to reduce sidebar
	 * stacking without hiding the active section they are working in.
	 * @returns {number}
	 */
	getVisiblePrimaryMenuCount() {
		/** @type {Role[]} */
		const activeRoles = this.props.auth?.roles ?? [];
		const visiblePrimaryMenus = [
			activeRoles.some(
				/**
				 * @param {Role} role
				 * @returns {boolean}
				 */
				(role) => roles.admin.includes(role)
			),
			activeRoles.includes('agent'),
			activeRoles.includes('homeowner'),
		];

		return visiblePrimaryMenus.filter(Boolean).length;
	}

	render() {
		const shouldCollapseTopLevelMenus =
			this.getVisiblePrimaryMenuCount() > 1;

		return (
			<React.Fragment>
				<AdminNavigationList
					collapsible={shouldCollapseTopLevelMenus}
					onListItemClick={this.props.handleCloseSideDrawer}
				/>
				<AgentNavigationList
					collapsible={shouldCollapseTopLevelMenus}
					onListItemClick={this.props.handleCloseSideDrawer}
				/>
				<HomeownerNavigationList
					collapsible={shouldCollapseTopLevelMenus}
					onListItemClick={this.props.handleCloseSideDrawer}
				/>
				<ProfileNavigationList
					collapsible={shouldCollapseTopLevelMenus}
					onListItemClick={this.props.handleCloseSideDrawer}
				/>
			</React.Fragment>
		);
	}
}
export default /** @type {React.ComponentType<Pick<Props, 'handleCloseSideDrawer'>>} */ (
	/** @type {(component: React.ComponentType<Props>) => React.ComponentType<Pick<Props, 'handleCloseSideDrawer'>>} */ (
		/** @type {unknown} */ (withAuth)
	)(AppNavigation)
);
